export default __webpack_public_path__ + "static/media/caio-paes.1bb6925f.jpg";